<template>
  <v-dialog
    :color="$app.opts.modalHeaderColor"
    :value="true"
    @keydown.esc="dismiss"
    @input="(v) => dismiss()"
    scrollable
    :max-width="$app.opts.modalSizeDefault"
    persistent
  >
    <flow-state-card :flow-id="flowId" :item="item" :dismiss="dismiss" v-if="current" />
    <v-loading v-else opaque />
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { VLoading } from '@argon/app/components'
import { Modal } from '@argon/app/mixins'
import { NAMESPACE } from '../store'
import { FlowStateCard } from '../components'

export default {
  name: 'flow-state-modal',
  mixins: [Modal],
  components: {
    FlowStateCard,
    VLoading
  },
  props: {
    flowId: {
      type: [String, Number],
      required: true
    },
    stateName: { type: String, required: true }
  },
  data() {
    return {
      returnPath: { name: 'flow' }
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['current']),
    item() {
      return this.current.meta.states.find((state) => state.name === this.stateName)
    }
  }
}
</script>
